import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Dialog } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { CheckCircle, Check, Lock, Close } from "@material-ui/icons";
import {
  continueVerification,
  showVerificationScreen,
} from "../../actions/index";

// Components
import VerificationModal from "./VerificationModal";
import Loader from "../Loader";

function AccountType(props) {
  const { t, classes, account, institutional } = props;
  const [bannerOpen, setBannerOpen] = useState(true);
  const [verifying, setVerifying] = useState(false);
  const [institutionStatus, setInstitutionStatus] = useState(null);

  const continueVerification = async () => {
    props.continueVerification(true);
    // props.showVerificationScreen(true);
  };

  useEffect(() => {
    if (institutional.institution) {
      const { institution } = institutional;

      if (
        institution.banks.length === 0 ||
        institution.representatives.length === 0 ||
        institution.documents.length === 0
      ) {
        setInstitutionStatus("not_complete");
        return;
      }

      if (institution.documents.length) {
        setInstitutionStatus(institution.status);
        return;
      }
    }
  }, [institutional]);

  if (account.account === null || typeof account.account === "undefined") {
    return <Loader />;
  }

  const { level } = account.account;
  const status = account.account.profile
    ? account.account.profile.status
    : "level_" + level;

  let bannerInfo = {
    title: "",
    message: "",
    type: "positive",
  };

  switch (status) {
    case "level_0":
      bannerInfo.title = "level0T";
      bannerInfo.message = "level0P";
      break;
    case "level_1":
      bannerInfo.title = "level1T";
      bannerInfo.message = "level1P";
      break;
    case "level_2":
      bannerInfo.title = "level2T";
      bannerInfo.message = "level2P";
      break;
    case "level_2_auto_rejected":
      if (account.account.documents.length === 0) {
        bannerInfo.title = "_similarProfileT";
        bannerInfo.message = "_similarProfileP";
        bannerInfo.type = "negative";
      } else {
        bannerInfo.title = "level3T";
        bannerInfo.message = "level3P";
        bannerInfo.type = "negative";
      }
      break;
    case "level_2_new_document":
      bannerInfo.title = "level4T";
      bannerInfo.message = "level4P";
      break;

    case "level_3":
      bannerInfo.title = "level3T";
      bannerInfo.message = "level3P";
      bannerInfo.type = "negative";
      break;
    case "level_3_new_document":
      bannerInfo.title = "level4T";
      bannerInfo.message = "level4P";
      break;
    case "level_4":
      bannerInfo.title = "jumioAcceptedT";
      bannerInfo.message = "jumioAcceptedP";
      break;
    case "level_4_pending":
      bannerInfo.title = "jumioProcessT";
      bannerInfo.message = "jumioProcessP";
      break;
    case "level_5":
      bannerInfo.title = "level5T";
      bannerInfo.message = "level5P";
      break;
    case "level_6_pending":
      bannerInfo.title = "level6pendingT";
      bannerInfo.message = "level6pendingP";
      break;
    case "level_6":
      bannerInfo.title = "level6T";
      bannerInfo.message = "level6P";
      break;
  }

  return (
    <div className={classes.accountTypeContainer}>
      <div className={`infoBanner positiveBanner`}>
        <div className="bannerContent ">
          <h3>{t("_bannerSoloT")}</h3>
          <p dangerouslySetInnerHTML={{ __html: t("_bannerSoloC") }} />
          {level === 0 ? (
            <button onClick={() => props.router.push("/id/verification")}>
              {t("verify")}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>

      <div className={`accTypes ${"soloUser"}`}>
        <div className={`practiseAcc typeBox ${level < 5 ? "activeAcc" : ""}`}>
          <div className="title">
            <h2>{t("practiseAccount")}</h2>
            <CheckCircle />
          </div>
          <div className="subtitle">
            <p>{t("_demoST")}</p>
          </div>
          <div className="typePerks">
            <p className="perk">
              <CheckCircle />
              {t("practisePerk1S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("practisePerk2S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("practisePerk3S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("practisePerk4S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("practisePerk5S")}
            </p>
          </div>
          {level < 5 ? (
            <p disabled className="currentBtn">
              {t("currentAccount")}
            </p>
          ) : (
            ""
          )}
        </div>
        {account.account.level === 5 ? (
          <div
            className={`liveTradingAcc typeBox ${
              level === 5 ? "activeAcc" : ""
            }`}
          >
            <div className={`title ${level < 5 ? "locked" : ""}`}>
              <h2>{t("limitedAccount")}</h2>
              {level === 5 ? <CheckCircle /> : <Lock />}
            </div>
            <div className="subtitle">
              <p>{t("_limitedT")}</p>
            </div>
            <div className="typePerks">
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk1")}
              </p>
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk2")}
              </p>
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk3")}
              </p>
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk4")}
              </p>
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk5")}
              </p>
              <p className="perk">
                <CheckCircle />
                {t("limitedPerk6")}
              </p>
            </div>
            {level === 5 ? (
              <p disabled className="currentBtn">
                {t("currentAccount")}
              </p>
            ) : (
              <button
                disabled={
                  level === 0 ||
                  account.account.profile?.status === "level_6_pending"
                    ? true
                    : false
                }
                onClick={() => continueVerification()}
                className="finishVerificationBtn"
              >
                {account.account.profile?.status === "level_6_pending"
                  ? t("_onReview")
                  : t("finishVerification")}
              </button>
            )}
          </div>
        ) : (
          ""
        )}
        <div className={"liveTradingAcc typeBox"}>
          <div className={`title ${level < 6 ? "locked" : ""}`}>
            <h2>{t("liveTradingAccount")}</h2>
            {level < 6 ? <Lock /> : <CheckCircle />}
          </div>
          <div className="subtitle">
            <p>{t("_proST")}</p>
          </div>
          <div className="typePerks">
            <p className="perk">
              <CheckCircle />
              {t("liveTradingPerk1S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("liveTradingPerk2S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("liveTradingPerk3S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("liveTradingPerk4S")}
            </p>
            <p className="perk">
              <CheckCircle />
              {t("liveTradingPerk5S")}
            </p>
          </div>
          {level === 6 ? (
            institutionStatus === "approved" ? (
              ""
            ) : (
              <p className="currentBtn">{t("currentAccount")}</p>
            )
          ) : (
            <p className="currentBtn">{t("_comingSoon")}</p>
          )}
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    account: state.account,
    institutional: state.institutional,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      showVerificationScreen,
      continueVerification,
    },
    dispatch
  );
}

const styles = (theme) => ({
  accountTypeContainer: {
    width: "100%",
    maxWidth: 1100,
    "& .infoBanner": {
      width: "100%",
      height: "auto",
      borderRadius: 2,
      display: "flex",
      alignItems: "center",
      marginBottom: 16,
      background: theme.colors.background.fore,
      position: "relative",
      borderLeft: `12px solid ${theme.colors.misc.success}`,
      boxShadow: theme.defaults.shadow,
      "&.negativeBanner": {
        borderColor: theme.colors.misc.fail,
        "& h3": {
          color: theme.colors.misc.fail,
        },
      },
      "& svg": {
        position: "absolute",
        top: 8,
        right: 8,
        transition: ".3s",
        cursor: "pointer",
        color: theme.colors.text.secondary,
        "&:hover": {
          opacity: 0.3,
        },
      },
      "& .bannerContent": {
        padding: "0 24px",
        display: "flex",
        flexDirection: "column",
        height: "auto",
        padding: "16px",
        justifyContent: "space-between",

        "& h3": {
          color: theme.colors.misc.success,
          fontSize: 18,
          // fontFamily: "Titillium Web",
          fontWeight: 600,
          marginBottom: 8,
        },
        "& p": {
          fontSize: 14,
          color: theme.colors.text.primary,
          lineHeight: "18px",
          // fontFamily: "Titillium Web",
          "& b": {
            color: theme.colors.text.primary,
            fontWeight: 600,
          },
          "& ul": {
            marginLeft: 24,
          },
          "& li": {
            listStyleType: "disc",
          },
          "& a": {
            color: theme.colors.text.primary,
          },
        },
        "& button": {
          ...theme.defaults.roundBtn,
          marginTop: 8,
          background: theme.colors.buttons.green,
          width: "100%",
          maxWidth: 150,
        },
      },

      [theme.breakpoints.down(700)]: {
        "& .bannerContent": {
          "& h3": {
            fontSize: `16px !important`,
          },
        },
      },
    },

    "& .accTypes": {
      display: "flex",
      justifyContent: "space-between",
      "& .typeBox": {
        width: "32%",
        borderRadius: 4,
        padding: "24px 20px",
        border: `1px solid ${theme.colors.background.inactive}`,
        color: theme.colors.text.tertiary,
        background: theme.colors.background.fore,
        position: "relative",

        "& button": {
          ...theme.defaults.roundBtn,
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          width: "80% !important",
        },

        "&.activeAcc": {
          background: theme.colors.background.inactive,
          "& .title": {
            color: theme.colors.buttons.green,
          },
          "& .typePerks": {
            "& .perk": {
              color: theme.colors.text.primary,
            },
          },
        },

        "& .title": {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: 85,
          paddingBottom: 16,
          borderBottom: `1px solid ${theme.colors.misc.dividers}`,
          color: theme.colors.text.secondary,
          "& h2": {
            width: "80%",
            fontSize: 28,
            // fontFamily: "Titillium Web",
            fontWeight: 600,
            lineHeight: "37px",
            display: "flex",
            flexDirection: "column",
          },
          "& svg": {
            fontSize: 32,
          },
          "& span": {
            fontSize: 15,
          },
        },

        "& .subtitle": {
          color: theme.colors.text.primary,
          fontWeight: 600,
          lineHeight: "24px",
          fontSize: 16,
          marginBottom: 24,
          borderBottom: `1px solid ${theme.colors.misc.dividers}`,
          height: 100,
          display: "flex",
          alignItems: "center",
        },

        "& .typePerks": {
          marginBottom: 100,
          "& .perk": {
            display: "flex",
            fontSize: 14,
            fontWeight: 500,
            // fontFamily: "Titillium Web",
            marginBottom: 8,
            lineHeight: "21px",
            letterSpacing: ".18px",
            "& svg": {
              color: theme.colors.buttons.green,
              marginRight: 12,
            },
          },
        },
        "& .currentBtn": {
          width: "90%",
          background: theme.colors.background.fore,
          borderRadius: 2,
          color: theme.colors.text.secondary,
          height: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // fontFamily: "Titillium Web",
          fontWeight: 600,
          border: "2px solid transparent",
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
        },

        "& .applyCorporateBtn": {
          width: "100%",
          background: theme.colors.buttons.green,
          border: "2px solid transparent",
          boxShadow: "none",
          "&:disabled": {
            background: theme.colors.background.inactive,
            color: theme.colors.text.tertiary,
          },
        },
        "& .finishVerificationBtn": {
          width: "100%",
          border: `2px solid ${theme.colors.buttons.green}`,
          background: theme.colors.buttons.green,
          boxShadow: "none",
          "&:disabled": {
            borderColor: theme.colors.background.inactive,
            color: theme.colors.text.tertiary,
          },
        },
      },

      "&  .corporateAcc": {
        "& .typePerks": {
          "& svg": {
            color: `${theme.colors.misc._blue} !important`,
          },
        },
      },

      [theme.breakpoints.down(700)]: {
        flexDirection: "column",
        "& .typeBox": {
          width: "100%",
          marginBottom: 8,
        },
      },
      "&.level5User": {
        "& .typeBox": {
          width: "24%",
        },

        [theme.breakpoints.down(1000)]: {
          flexWrap: "wrap",
          "& .typeBox": {
            width: "47.5%",
            marginBottom: 8,
          },
        },

        [theme.breakpoints.down(700)]: {
          flexDirection: "column",
          "& .typeBox": {
            width: "100% !important",
            marginBottom: 8,
          },
        },
      },
      "&.soloUser": {
        "& .typeBox": {
          width: "47.5%",
        },
        [theme.breakpoints.down(700)]: {
          flexDirection: "column",
          "& .typeBox": {
            width: "100% !important",
            marginBottom: 8,
          },
        },
      },
    },
  },
  upgradeDialog: {
    // background: theme.colors.background.main,
    background: "transparent",
    width: "95%",
    maxWidth: 1100,
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AccountType))
);
